const COMPANY_THEME_SETTINGS = {
  THEME_SETTINGS_INITIALIZATION: "THEME_SETTINGS_INITIALIZATION",
  THEME_SETTINGS_SUCCESS: "THEME_SETTINGS_SUCCESS",
  THEME_SETTINGS_ERROR: "THEME_SETTINGS_ERROR"
};

export {COMPANY_THEME_SETTINGS}
